// import isEmpty  from 'lodash/isEmpty';


let compName = 'participants'

const initialState = {
    list:[],
}

export default (state = initialState, action = {}) => {
    
    // when user logs in, we set uid on the state object.
    switch (action.type) {
       
        case 'SET_AUTO_SUGGEST_EMAIL_VALUE':  
            return {
                autosuggestEmailValue: action.email
            }
        case 'UPDATE_PARTICIPANTS': 
            return {
                list: action.list
            }
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/participants.js